import { Terminal } from 'lucide-react';

export function QuestionHeader({ questionIndex, isRequired, currentQuestion, isTyping, language }) {
  return (
    <div className="flex items-start gap-3 mb-8">
      <Terminal className="w-5 h-5 text-neon-green mt-1 flex-shrink-0" />
      <div className="flex-1">
        <div className="flex items-center gap-2 mb-2">
          <span className="font-mono text-xs text-neon-green/70">
            {language === 'it' ? 'DOMANDA' : 'QUESTION'}_{String(questionIndex + 1).padStart(3, '0')}
          </span>
          {isRequired && (
            <span className="font-mono text-xs text-neon-red px-2 py-0.5 bg-neon-red/10 rounded">
              {language === 'it' ? 'OBBLIGATORIA' : 'REQUIRED'}
            </span>
          )}
        </div>
        <p 
          className={`font-sans text-lg text-white leading-relaxed ${isTyping ? 'typing-effect' : ''}`}
          data-testid="current-question"
        >
          {currentQuestion}
        </p>
      </div>
    </div>
  );
}

export function ProgressBar({ questionIndex, totalQuestions, language, t }) {
  const progress = Math.min((questionIndex / totalQuestions) * 100, 95);
  
  return (
    <div className="mb-8 fade-in-up" style={{ animationDelay: '0.1s' }}>
      <div className="flex justify-between mb-2 font-mono text-xs text-gray-400">
        <span>{t('questionNumber')} {questionIndex + 1}</span>
        <span>{Math.round(progress)}%</span>
      </div>
      <div className="cyber-progress h-2 rounded-full">
        <div 
          className="cyber-progress-bar h-full rounded-full"
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>
  );
}
